import { useEffect } from 'react';
import { Box, Container } from '@mui/material';
import { Button, Text } from '@qwickapps/react-framework';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@qwickapps/auth-client';

export default function LandingPage() {
  const navigate = useNavigate();
  const { user, session } = useAuth();

  // Redirect to dashboard if user is already signed in
  useEffect(() => {
    if (user && session?.accessToken) {
      navigate('/dashboard');
    }
  }, [user, session, navigate]);

  const handleGetStarted = () => {
    navigate('/login');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          gap: 4,
        }}
      >
        <Text variant="h2" customColor="var(--theme-text-primary)" content="QwickForge IDE" />
        <Text variant="h5" customColor="var(--theme-text-secondary)" content="AI Development. Your Compute. Your Privacy." sx={{ maxWidth: 600 }} />
        <Text variant="body1" customColor="var(--theme-text-secondary)" content="Run AI agents on your own hardware. Pay only for coordination, not compute. No vendor lock-in." sx={{ maxWidth: 600 }} />
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            size="large"
            onClick={handleGetStarted}
          >
            Get Started Free →
          </Button>
          <Button
            variant="outlined"
            size="large"
            onClick={handleLogin}
          >
            Sign In
          </Button>
        </Box>
        <Box sx={{ display: 'flex', gap: 4, mt: 2 }}>
          <Text variant="body2" content="✓ Your compute, your costs" />
          <Text variant="body2" content="✓ Privacy by default" />
          <Text variant="body2" content="✓ Multi-device coordination" />
        </Box>
      </Box>
    </Container>
  );
}
